<style lang="less" scoped>
@import "../../styles/variable.less";
#storage-list {
  /deep/ .storage-item {
    display: flex;
  }
  /deep/ .ant-card {
    border-radius: 5px;
    padding: 5px;
    &-body {
      padding: 15px 10px;
    }
    &-cover {
      position: relative;
      .storage-thumbnail {
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        max-height: 160px;
        border-radius: 5px;
        overflow: hidden;
        vertical-align: bottom;
      }
      .ant-image {
        opacity: 0;
      }
    }
    &-meta {
      &-title {
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 0;
        a {
          color: inherit;
        }
      }
    }
    .taglist {
      margin: 0;
      padding: 0;
      &-item {
        display: inline-block;
        font-size: 12px;
        color: @gray01;
        white-space: nowrap;
        margin-top: 5px;
        &:after {
          content: ",";
          display: inline-block;
          color: @gray03;
          margin: 0 5px;
        }
        &:last-child {
          &:after {
            content: none;
          }
        }
      }
    }
    .data-overlay {
      background: rgba(@white01, 0.9);
      display: flex;
      align-items: center;
      font-size: 12px;
      width: 100%;
      padding: 5px;
      position: absolute;
      left: 0;
      bottom: 0;
      &-text {
        flex-grow: 1;
        padding-left: 5px;
        margin-bottom: 0;
      }
      &-btn {
        background: none;
        color: @blue01;
        width: auto;
        height: auto;
        padding: 3px 12px;
        border: solid 1px;
        border-radius: 5px;
      }
    }
  }
}
.storage-download-modal {
  &.pdf {
    embed {
      width: 100%;
      min-height: 500px;
    }
  }
}
</style>
<style lang="less">
.storage-download-modal {
  &.pdf {
    width: 90vw !important;
  }
}
</style>
<template>
  <div id="storage-list">
    <a-row :gutter="[10, 10]">
      <a-col
        class="storage-item"
        v-for="storageFile in storageFiles"
        :key="storageFile.id"
        :span="6"
        :xs="24"
        :sm="12"
        :md="12"
        :lg="8"
        :xl="6"
        :xxl="4"
      >
        <a-card style="width: 100%">
          <template #cover>
            <div
              class="storage-thumbnail"
              :style="{
                backgroundImage:
                  'url(' + (storageFile.thumbnailPath || fallbackImage) + ')',
              }"
            >
              <a-image
                width="100%"
                :src="storageFile.thumbnailPath || fallbackImage"
                :fallback="fallbackImage"
                :preview="false"
              />
            </div>
            <div class="data-overlay">
              <p class="data-overlay-text">格納データ</p>
              <a-button
                class="data-overlay-btn"
                @click="hendleOpenDetail(storageFile)"
              >
                <template #icon><DownloadOutlined /></template>
              </a-button>
            </div>
          </template>
          <a-card-meta>
            <template #title>{{ storageFile.name }}</template>
            <template #description>
              {{ storageFile.note }}
            </template>
          </a-card-meta>
        </a-card>
      </a-col>
    </a-row>
    <a-modal
      class="storage-download-modal"
      title="ダウンロードしますか？"
      :visible="visibleModal"
      :okButtonProps="{
        href: currentStorageFile.originalPath,
        download: '',
      }"
      @cancel="hendleCloseDetail"
      v-if="currentStorageFile != null"
      v-bind:class="
        currentStorageFile.mimeType.indexOf('/pdf') !== -1 ? 'pdf' : ''
      "
    >
      <template v-if="currentStorageFile != null">
        <template v-if="currentStorageFile.mimeType.indexOf('/pdf') !== -1">
          <embed
            :src="currentStorageFile.originalPath"
            :type="currentStorageFile.mimeType"
          />
        </template>
        <template v-else>
          <a-image
            width="100%"
            :src="currentStorageFile.thumbnailPath || fallbackImage"
            :fallback="fallbackImage"
            :preview="false"
          />
        </template>
        <a :href="currentStorageFile.originalPath" download>
          <a-button type="default" block>
            ダウンロード
            <DownloadOutlined key="download" />
          </a-button>
        </a>
      </template>
    </a-modal>
  </div>
</template>
<script lang="ts">
import { computed, defineComponent, reactive, toRefs } from "vue";
import { useResult } from "@vue/apollo-composable";
import { DownloadOutlined } from "@ant-design/icons-vue";
import {
  GetManyClientStorageFileQuery,
  ClientStorageFile,
} from "@/client/schema";
import { useGetManyClientStorageFileQuery } from "@/client/modules/api";

export type Props = {
  clientUserGroupId: string;
};

const fallbackImage =
  "data:image/png;base64,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";

export default defineComponent({
  components: {
    DownloadOutlined,
  },
  props: {
    clientUserGroupId: {
      type: String,
      required: false,
      default: null,
    },
  },
  setup(props: Props) {
    const state = reactive({
      currentStorageFile: null as ClientStorageFile | null,
    });

    const { result: filesResult, loading } = useGetManyClientStorageFileQuery({
      clientUserGroupId: props.clientUserGroupId,
    });

    const storageFiles =
      useResult<GetManyClientStorageFileQuery, "clientStorageFiles">(
        filesResult
      );

    const hendleOpenDetail = (storageFile: ClientStorageFile) => {
      state.currentStorageFile = storageFile;
    };

    const hendleCloseDetail = () => {
      state.currentStorageFile = null;
    };

    const visibleModal = computed(() => {
      return state.currentStorageFile !== null;
    });

    return {
      ...toRefs(state),
      storageFiles,
      loading,
      fallbackImage,
      hendleOpenDetail,
      hendleCloseDetail,
      visibleModal,
    };
  },
});
</script>
